import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { SupportToolsComponent } from './support-tools/support-tools.component';
import { FrontendToolsComponent } from './frontend-tools/frontend-tools.component';

@Component({
	selector: 'dev-settings',
	templateUrl: './dev-settings.component.html',
	styleUrls: ['./dev-settings.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, MatTabGroup, MatTab, SupportToolsComponent, FrontendToolsComponent],
})
export class DevSettingsComponent {
	translocoService = inject(TranslocoService);
}
